import React from "react";

const ManifoldAnalyticsContext = React.createContext();

export default ManifoldAnalyticsContext;
